// src/components/Testimonials.jsx
import React from "react";
import { Card, CardContent } from "./ui/card";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-white"
    >
      <div className="max-w-5xl mx-auto text-center">

        {/* ------------------- HEADER ------------------- */}
        <div className="mb-14">
          <h2 className="text-4xl sm:text-5xl font-bold text-[var(--aerzen-black)] mb-4">
            Pilot Programs & Early Deployments
          </h2>

          <p className="text-lg text-[var(--aerzen-black)]/70 max-w-3xl mx-auto leading-relaxed">
            AERZEN AIR™ systems are currently undergoing controlled pilot
            deployments across select institutional environments in India.
            These programs focus on validating real-world performance,
            reliability, and continuous-duty operation.
          </p>
        </div>

        {/* ------------------- PILOT VALIDATION CARDS ------------------- */}
        <div className="grid md:grid-cols-2 gap-10">

          {/* Card 1 */}
          <Card className="border border-[var(--aerzen-silver)] bg-white shadow-sm rounded-2xl">
            <CardContent className="p-10 text-left">
              <h3 className="text-xl font-semibold text-[var(--aerzen-black)] mb-4">
                Performance Validation Focus
              </h3>

              <ul className="space-y-2 text-[var(--aerzen-black)]/70 text-base">
                <li>• Indoor PM2.5 reduction efficiency</li>
                <li>• Airflow stability over extended operation</li>
                <li>• Noise levels at rated capacity</li>
                <li>• Energy consumption profiling</li>
              </ul>
            </CardContent>
          </Card>

          {/* Card 2 */}
          <Card className="border border-[var(--aerzen-silver)] bg-white shadow-sm rounded-2xl">
            <CardContent className="p-10 text-left">
              <h3 className="text-xl font-semibold text-[var(--aerzen-black)] mb-4">
                Deployment & Lifecycle Assessment
              </h3>

              <ul className="space-y-2 text-[var(--aerzen-black)]/70 text-base">
                <li>• Multi-unit deployment planning</li>
                <li>• Service access and maintenance workflow</li>
                <li>• Filter life and pressure-drop behavior</li>
                <li>• Suitability for institutional operating hours</li>
              </ul>
            </CardContent>
          </Card>

        </div>

        {/* ------------------- FOOTNOTE ------------------- */}
        <div className="mt-16 max-w-3xl mx-auto">
          <p className="text-[var(--aerzen-black)]/65 text-base leading-relaxed">
            Detailed case studies and performance reports will be published
            after completion of monitored deployment cycles.  
            AERZEN AIR™ does not publish speculative testimonials or unverified claims.
          </p>
        </div>

      </div>
    </section>
  );
};
